/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { i18nData } from 'helpers/i18n';
import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticeHandsHips3 from '../../images/characters/apprenticeHandsHips3.png';
import apprenticeArmsFolded2 from '../../images/characters/apprenticeArmsFolded2.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';
import apprenticesBackToBack from '../../images/characters/apprenticesBackToBack.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1_en from './level1_drawSeasons.md';
import markdownFileLevel1_fr_CA from './level1_drawSeasons.fr_CA.md';
import markdownFileLevel2a_en from './level2a_drawEnergy.md';
import markdownFileLevel2a_fr_CA from './level2a_drawEnergy.fr_CA.md';
import markdownFileLevel2b_en from './level2b_energySavingRap.md';
import markdownFileLevel2b_fr_CA from './level2b_energySavingRap.fr_CA.md';
import markdownFileLevel3a_en from './level3a_modelHotWaterTank.md';
import markdownFileLevel3a_fr_CA from './level3a_modelHotWaterTank.fr_CA.md';
import markdownFileLevel3b_en from './level3b_showerPoster.md';
import markdownFileLevel3b_fr_CA from './level3b_showerPoster.fr_CA.md';
import markdownFileLevel4a_en from './level4a_drawTransportation.md';
import markdownFileLevel4a_fr_CA from './level4a_drawTransportation.fr_CA.md';
import markdownFileLevel4b_en from './level4b_rateTransportation.md';
import markdownFileLevel4b_fr_CA from './level4b_rateTransportation.fr_CA.md';
import markdownFileLevel5a_en from './level5a_teamBrainstorm.md';
import markdownFileLevel5a_fr_CA from './level5a_teamBrainstorm.fr_CA.md';
import markdownFileLevel5b_en from './level5b_rolePlay.md';
import markdownFileLevel5b_fr_CA from './level5b_rolePlay.fr_CA.md';
import markdownFileLevel6_en from './level6_papercrafts.md';
import markdownFileLevel6_fr_CA from './level6_papercrafts.fr_CA.md';

const markdownFileLevel1 = i18nData({
  en: new MarkdownScript(markdownFileLevel1_en),
  fr_CA: new MarkdownScript(markdownFileLevel1_fr_CA)
});
const markdownFileLevel2a = i18nData({
  en: new MarkdownScript(markdownFileLevel2a_en),
  fr_CA: new MarkdownScript(markdownFileLevel2a_fr_CA)
});
const markdownFileLevel2b = i18nData({
  en: new MarkdownScript(markdownFileLevel2b_en),
  fr_CA: new MarkdownScript(markdownFileLevel2b_fr_CA)
});
const markdownFileLevel3a = i18nData({
  en: new MarkdownScript(markdownFileLevel3a_en),
  fr_CA: new MarkdownScript(markdownFileLevel3a_fr_CA)
});
const markdownFileLevel3b = i18nData({
  en: new MarkdownScript(markdownFileLevel3b_en),
  fr_CA: new MarkdownScript(markdownFileLevel3b_fr_CA)
});
const markdownFileLevel4a = i18nData({
  en: new MarkdownScript(markdownFileLevel4a_en),
  fr_CA: new MarkdownScript(markdownFileLevel4a_fr_CA)
});
const markdownFileLevel4b = i18nData({
  en: new MarkdownScript(markdownFileLevel4b_en),
  fr_CA: new MarkdownScript(markdownFileLevel4b_fr_CA)
});
const markdownFileLevel5a = i18nData({
  en: new MarkdownScript(markdownFileLevel5a_en),
  fr_CA: new MarkdownScript(markdownFileLevel5a_fr_CA)
});
const markdownFileLevel5b = i18nData({
  en: new MarkdownScript(markdownFileLevel5b_en),
  fr_CA: new MarkdownScript(markdownFileLevel5b_fr_CA)
});
const markdownFileLevel6 = i18nData({
  en: new MarkdownScript(markdownFileLevel6_en),
  fr_CA: new MarkdownScript(markdownFileLevel6_fr_CA)
});

const levels = {
  '1': { md: markdownFileLevel1 },
  '2a': { md: markdownFileLevel2a },
  '2b': { md: markdownFileLevel2b },
  '3a': { md: markdownFileLevel3a },
  '3b': { md: markdownFileLevel3b },
  '4a': { md: markdownFileLevel4a },
  '4b': { md: markdownFileLevel4b },
  '5a': { md: markdownFileLevel5a },
  '5b': { md: markdownFileLevel5b },
  '6': { md: markdownFileLevel6 }
};

export function preloadClassActivity () {
  preloader([
    esHandsOutWehey,
    apprenticeHandsHips3,
    apprenticeArmsFolded2,
    apprenticesBackToBack,
    ianSaraLeanQuestioning,
    esHandsOutWehey
  ]);
}

function sizzle (level, regionData, md) {
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'left',
      characterImage: apprenticeHandsHips3,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function introVideo (level, regionData, md) {
  return (
    videoSlide({
      id: 'intro-video',
      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
    })
  );
}

function instructions (level, regionData, md) {
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'right',
      characterImage: apprenticeArmsFolded2,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}

function scoring (level, regionData, md) {
  return (
    balloonSlide({
      id: 'scoring',
      characterSide: 'right',
      characterImage: apprenticesBackToBack,
      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
    })
  );
}

function level1 (regionData, i18n) { // Group drawing
  const level = '1';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level2a (regionData, i18n) { // Draw Energy
  const level = '2a';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level2b (regionData, i18n) { // Energy saving rap
  const level = '2b';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

      {/* Scoring */}
      {scoring(level, regionData, md)}

      {/* Rap Backtrack Practice */}
      {videoSlide({
        id: 'rap-backtrack-practice',
        notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
      })}

      {/* Performing Intro Video */}
      {videoSlide({
        id: 'performing-intro-video',
        notes: md.getSubSectionAsHtml('Performing Intro Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Performing Intro Video', 'YouTube', regionData)
      })}

      {/* Rap Backtrack Perform */}
      {videoSlide({
        id: 'rap-backtrack-perform',
        notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
      })}

    </Section>
  );
}

function level3a (regionData, i18n) { // Model hot water tank
  const level = '3a';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level3b (regionData, i18n) { // Draw shower power poster
  const level = '3b';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}


function level4a (regionData, i18n) { // Draw different types of transportation
  const level = '4a';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Energy Demonstration Intro */}
      {balloonSlide({
        id: 'energy-demo-intro',
        characterSide: 'left',
        characterImage: esHandsOutWehey,
        notes: md.getSubSectionAsHtml('Energy Demonstration Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Energy Demonstration Intro', 'Content', false, regionData)
      })}

      {/* Energy Demonstration Video */}
      {videoSlide({
        id: 'energy-demo-video',
        notes: md.getSubSectionAsHtml('Energy Demonstration Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Energy Demonstration Video', 'YouTube', regionData)
      })}

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level4b (regionData, i18n) { // Rate transportation options
  const level = '4b';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

    {/* Sizzle */}
    {sizzle(level, regionData, md)}

    {/* Intro Video */}
    {introVideo(level, regionData, md)}

    {/* Instructions */}
    {instructions(level, regionData, md)}

    </Section>
  );
}

function level5a (regionData, i18n) { // Team brainstorm
  const level = '5a';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

      {/* Class Discussion */}
      {balloonSlide({
        id: 'class-discussion',
        characterSide: 'right',
        characterImage: ianSaraLeanQuestioning,
        notes: md.getSubSectionAsHtml('Class Discussion', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Class Discussion', 'Content', false, regionData)
      })}

    </Section>
  );
}

function level5b (regionData, i18n) { // Role play
  const level = '5b';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Intro Video */}
      {introVideo(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level6 (regionData, i18n) { // Papercrafts
  const level = '6';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

    {/* Sizzle */}
    {sizzle(level, regionData, md)}

    {/* Intro Video */}
    {introVideo(level, regionData, md)}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData, i18n }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1':
    return level1(regionData, i18n);
  case '2a':
    return level2a(regionData, i18n);
  case '2b':
    return level2b(regionData, i18n);
  case '3a':
    return level3a(regionData, i18n);
  case '3b':
    return level3b(regionData, i18n);
  case '4a':
    return level4a(regionData, i18n);
  case '4b':
    return level4b(regionData, i18n);
  case '5a':
    return level5a(regionData, i18n);
  case '5b':
    return level5b(regionData, i18n);
  case '6':
    return level6(regionData, i18n);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/30_classActivity/classActivitySection.jsx